import React from "react";

export default function Trucks() {
  return (
    <div className="container-xxl">
      <div className="container py-5">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="text-secondary text-uppercase">Vehicle available</h6>
          <h1 className="mb-5">Explore Our Vehicles</h1>
        </div>

        <div className="row g-4">
          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/1.jpg"
                  alt="Air Freight"
                />
              </div>
              <h4 className="mb-3">ACE / DOST / PICKUP (1.5 TON)</h4>
              <p>
                ACE / DOST / PICKUP (1.5 TON) 196 Transport services and the
                vehicles you have available
              </p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/2.jpg"
                  alt="Ocean Freight"
                />
              </div>
              <h4 className="mb-3">Eicher 2.5 ton</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/3.jpg"
                  alt="Road Freight"
                />
              </div>
              <h4 className="mb-3">EICHER 14FT (3.5 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/4.jpg"
                  alt="Train Freight"
                />
              </div>
              <h4 className="mb-3">EICHER 17FT (5 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/5.jpg"
                  alt="Customs Clearance"
                />
              </div>
              <h4 className="mb-3">EICHER 19FT (7 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/6.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">20FT CONTAINER (6.5 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/7.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">EICHER PRO 22FT (10 /12 /TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/8.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">EICHER 14FT (3.5 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/9.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">SELECT TRUCK LATER OPEN TRUCKS</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/10.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">32FT CONTAINER (15 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/11.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">LORRY/TAURUS (18/21/25 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/12.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">32FT CONTAINER (18 TON)</h4>
              <p>Transport services and the vehicles you have available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
